import styled, { keyframes } from "styled-components";

const shimmer = keyframes`
  0% { background-position: -500px 0; }
  100% { background-position: 500px 0; }
`;

export const BackButton = styled.button`
  background: none;
  border: none;
  color: #fff;
  font-family: Figtree;
  font-size: 15px;
  font-weight: 400;
  letter-spacing: -0.075px;
  display: flex;
  flex-direction: row;
  align-items: center;
  cursor: pointer;
  opacity: 0.5;
  transition: all 0.2s ease-in-out;

  &:hover {
    opacity: 1;
  }
`;

export const TitleContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const TitleRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 6px;
  flex-wrap: wrap;
  justify-content: space-between;
  margin-top: 16px;
  margin-left: -4px;
`;

export const Title = styled.h1`
  color: #fff;
  font-family: Figtree;
  font-size: 26px;
  font-weight: 500;
  line-height: 150%;
  letter-spacing: -0.1px;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const FavoriteButton = styled.div`
  width: 32px;
  height: 32px;
  position: relative;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  width: 100%;
  margin: 0 auto;
`;

export const FormCard = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
  max-width: 720px;
`;

export const Column = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  width: 100%;
`;

export const LabelRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 6px;
`;

export const LabelText = styled.span`
  color: #fff;
  font-family: Figtree;
  font-size: 14px;
  font-weight: 500;
  letter-spacing: -0.21px;
  text-align: left;
`;

export const InfoIconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  position: relative;

  svg {
    width: 16px;
    height: 16px;
    opacity: 0.5;

    path {
      stroke: ${(p) => (p.$active ? "rgba(63, 136, 247, 1)" : "#fff")};
    }
  }
`;

export const TooltipContainer = styled.div`
  border-radius: 16px;
  border: 1px solid #142743;
  background: #081120;
  padding: 16px;
  position: absolute;
  top: 24px;
  left: -24px;
  width: min(340px, calc(100vw - 72px));
  max-height: 180px;
  overflow-y: auto;
  gap: 8px;
  z-index: 100;
  display: flex;
  flex-direction: column;
  box-shadow: 0 12px 32px rgba(0, 0, 0, 0.35);
  text-align: left;
`;

export const TooltipText = styled.p`
  color: #fff;
  font-family: Figtree;
  font-size: 14px;
  font-weight: 400;
  line-height: 18px;
  letter-spacing: -0.07px;
  margin: 0;
  word-break: break-word;
`;

export const Textarea = styled.textarea`
  display: flex;
  padding: 12px;
  align-items: center;
  gap: 10px;
  align-self: stretch;
  border-radius: 12px;
  border: 1px solid #325682;
  background: #142743;
  font-family: Figtree;
  color: #fff;
  font-size: 14px;
  font-weight: 500;
  letter-spacing: -0.21px;
  resize: vertical;
  min-height: 126px;
  outline: none;

  &::placeholder {
    color: #71717a;
  }
`;

export const CheckboxContainerColumn = styled.div`
  display: flex;
  gap: 6px;
  flex-direction: column;
  width: 100%;
`;

export const CheckboxContainer = styled.div`
  display: flex;
  padding: 6px 8px;
  background: #0e1c31;
  border-radius: 12px;
  align-items: center;
  cursor: pointer;
  gap: 6px;
  align-self: stretch;
  flex-direction: row;
  height: 33px;
`;

export const CheckboxText = styled.div`
  position: relative;
  font-family: Figtree;
  color: #fff;
  font-size: 14px;
  font-weight: 500;
  letter-spacing: -0.21px;
`;

export const AspectRatioContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  width: 100%;
`;

export const AspectRatioOption = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  flex: 1;
  padding: 12px 0;
  cursor: pointer;
  border-radius: 12px;
  background: ${(p) => (p.$selected ? "transparent" : "#142743")};
  border: ${(p) => (p.$selected ? "1px solid #2877d9" : "1px solid #325682")};
  transition: border 0.2s ease;
`;

export const AspectRatioPreviewWrapper = styled.div`
  width: 22px;
  height: 22px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const AspectRatioPreview = styled.div`
  width: ${(p) => p.$width}px;
  height: ${(p) => p.$height}px;
  border-radius: 4px;
  background: ${(p) => (p.$selected ? "#2877D9" : "#274772")};
  border: ${(p) => (p.$selected ? "none" : "1px solid #223f68")};
  transition: all 0.2s ease;
`;

export const AspectRatioLabel = styled.span`
  font-family: Figtree;
  color: #fff;
  text-align: center;
  font-size: 14px;
  font-weight: 600;
  letter-spacing: -0.21px;
`;

export const GenerateRow = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
`;

export const SettingsIconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  width: 24px;
  height: 24px;
`;

export const CreditBadge = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 2px;
  color: #0f2c32;
  font-family: Figtree;
  font-size: 13px;
  font-weight: 800;
  letter-spacing: -0.065px;
`;

export const SectionTitle = styled.h2`
  color: #fff;
  font-family: Figtree;
  font-size: 18px;
  font-weight: 600;
  letter-spacing: -0.09px;
  margin-top: 8px;
`;

export const TabContentSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;
`;

export const MasonryGrid = styled.div`
  display: flex;
  gap: 4px;
  width: 100%;
`;

export const PaginationWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  margin-top: 16px;
  margin-bottom: 1.6rem;
`;

export const MasonryColumn = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const EmptyState = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 60px 20px;
  text-align: center;
  width: 100%;

  h3 {
    font-size: 20px;
    color: white;
    margin-bottom: 8px;
    font-family: Figtree;
    font-weight: 600;
  }

  p {
    font-size: 14px;
    line-height: 1.5;
    max-width: 400px;
    font-family: Figtree;
    color: white;
    opacity: 0.5;
  }
`;

export const SkeletonBox = styled.div`
  background: linear-gradient(180deg, #162b49 0%, #0f1e34 100%);
  border-radius: ${(p) => p.$radius || "12px"};
  width: ${(p) => p.$width || "100%"};
  ${(p) => p.$maxWidth && `max-width: ${p.$maxWidth};`}
  height: ${(p) => p.$height || "20px"};
  position: relative;
  overflow: hidden;

  &::after {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: linear-gradient(
      to right,
      rgba(255, 255, 255, 0) 0%,
      rgba(255, 255, 255, 0.08) 50%,
      rgba(255, 255, 255, 0) 100%
    );
    background-size: 1000px 100%;
    animation: ${shimmer} 2.5s ease-in-out infinite forwards;
  }
`;
